import { useTranslation } from "react-i18next";
import { displayToast } from "../../../components/app/AppToast";
import { useOnboardingGuard } from "../../user/hooks/useOnboardingGuard";
import { shareUrl } from "../../app/utils/shareUrl";
import type { ApiPodcastModel } from "./useGetPodcastsListQuery";

export type UseSharePodcast = {
  triggerShare: (podcast: ApiPodcastModel, roomId: string) => Promise<void>;
};

export function useSharePodcast(): UseSharePodcast {
  const { t } = useTranslation();
  const onboardingGuard = useOnboardingGuard();

  const triggerShare = async (
    podcast: ApiPodcastModel,
    roomId: string
  ): Promise<void> => {
    try {
      if (
        !onboardingGuard(
          t("🔒 Please complete your profile first to share this content. ")
        )
      ) {
        return;
      }

      const url = `${globalThis.location.origin}/room/podcast/${roomId}/${podcast.id}`;
      const ownerName = podcast.owner === null ? null : podcast.owner.name;
      const text =
        ownerName === null
          ? t("I think you might be interested in this podcast: {{title}}.", {
              title: podcast.title,
            })
          : t(
              "I think you might be interested in this podcast: {{title}} by {{publisherName}}.",
              { title: podcast.title, publisherName: ownerName }
            );

      await shareUrl(podcast.title, text, Promise.resolve(url));
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") return;
      displayToast(t("Something went wrong. Please try again."), "error");
    }
  };

  return { triggerShare };
}
